import styled from '@emotion/styled';
import type { DataGridProps } from '@mui/x-data-grid';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import React from 'react';

export const ChargesEditDataGrid = styled((props: DataGridProps) => (
  <DataGrid {...props}/>
))`
  background: #FFFFFF;
  border-radius: 8px;
  border-color: #E7EEF3;
  .${gridClasses.columnHeaders} {
    border: none;
  }
  .${gridClasses.columnHeaderTitle} {
    color: #576063;
    font-weight: 400;
    font-size: 12px;
    padding-left: 4px;
    padding-right: 4px;
  }
  .${gridClasses.cell} {
    border-top: 1px solid #E7EEF3;
    border-bottom: none;
    padding-left: 16px;
    padding-right: 16px;
  }
  .${gridClasses.cell}:focus-within, .${gridClasses.cell}:focus, .${gridClasses.columnHeader}:focus, .${gridClasses.columnHeader}:focus-within {
    outline: none;
  }
  .${gridClasses.virtualScroller}::-webkit-scrollbar {
    display: none;
  }
  .${gridClasses.columnSeparator} {
    display: none;
  }
`;